import axiosInstance from '../RestClient';

const BASE_URI = '/assets';
class AssetService {
	async list({ slim } = {}) {
		const uri = `${BASE_URI}/`;
		const response = await axiosInstance.get(uri, slim ? { params: { slim: true } } : undefined);
		return response;
	}

	async getDetails(recordId) {
		const uri = `${BASE_URI}/${recordId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async create(payload) {
		const response = await axiosInstance.post(`${BASE_URI}/`, payload);
		return response;
	}

	async edit(recordId, payload) {
		const response = await axiosInstance.put(`${BASE_URI}/${recordId}`, payload);
		return response;
	}

	async delete(recordId) {
		const uri = `${BASE_URI}/${recordId}`;
		const response = await axiosInstance.delete(uri);
		return response;
	}

	async getDeletionPreview(recordId) {
		return axiosInstance.get(`${BASE_URI}/${recordId}/deletion-preview`);
	}

	async search(query) {
		const uri = `${BASE_URI}/search?${query}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async getForWarranty() {
		const uri = `${BASE_URI}/forWarranty`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async listAssetsByAccount(accountId) {
		const uri = `${BASE_URI}/mine/${accountId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async uploadEscritura(formData) {
		const uri = `${BASE_URI}/uploadEscritura`;
		const response = await axiosInstance.post(uri, formData, { headers: { 'Content-Type': undefined } });
		return response;
	}

	async getWithDocuments() {
		const uri = `${BASE_URI}/withDocuments`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async listForDashboard() {
		const uri = `${BASE_URI}/dashboard`;
		const response = await axiosInstance.get(uri);
		return response;
	}
}
export default new AssetService();
